// extracted by mini-css-extract-plugin
module.exports = {"form":"login_form_179U2"};